// extracted by mini-css-extract-plugin
export default {"lowStockLabel":"G8-z"};